// extracted by mini-css-extract-plugin
module.exports = {"active":"statusColumn_active__1-1H3","deactivated":"statusColumn_deactivated__3vy6Y","awaiting":"statusColumn_awaiting__2mA5r"};